<template>
  <article class="newsletter">
    <header>
      <h1 class="title">{{ $t('title') }}</h1>
      <p class="subtitle">{{ $t('subtitle') }}</p>
    </header>
    <main>
      <i18n tag="p" path="text[0]"/>
      <i18n tag="p" path="text[1]">
        <template v-slot:twitter>
          <a :href="twitterUrl">Twitter</a>
        </template>
      </i18n>
      <i18n tag="p" path="text[2]"/>
      <i18n tag="h2" path="sectionHeadings[0]"/>
      <i18n tag="p" path="text[3]"/>
      <i18n tag="h2" path="sectionHeadings[1]"/>
      <i18n tag="p" path="text[4]">
        <template v-slot:contactForm>
          <router-link :to="{name: 'contact'}">
            {{ $t('contactForm') }}
          </router-link>
        </template>
      </i18n>
      <i18n tag="h2" path="sectionHeadings[2]"/>
      <p>
        {{ $t('text[5]') }}<br>
        {{ $t('text[6]') }}
      </p>
      <i18n tag="p" path="text[7]"/>
      <i18n tag="p" path="text[8]"/>
      <p>
        {{ $t('text[9]') }}<br>
        {{ $t('text[10]') }}<br>
        {{ $t('text[11]') }}
      </p>
      <i18n tag="h2" path="sectionHeadings[3]"/>
      <p>
        {{ $t('text[12]') }}<br>
        {{ $t('text[13]') }}
      </p>
      <i18n tag="p" path="text[14]"/>
      <i18n tag="p" path="text[15]"/>
      <i18n tag="p" path="text[16]"/>
      <i18n tag="p" path="text[17]"/>
    </main>
  </article>
</template>
<script>
export default {
  data() {
    return {
      twitterUrl: "https://twitter.com/frechdax_abdl",
    };
  },
}
</script>
<i18n src="./i18n.json"/>
